import { Component, inject, signal } from '@angular/core';
import { AboutUsProducts } from '../../shared/types/common.types';
import { SeoService } from '../../shared/seo.service';
import { SEO_PAGES_CONFIG } from '../../shared/header/header.lists';
import { Pages } from '../../shared/types/common.enums';

@Component({
  selector: 'app-school-field-trips',
  imports: [],
  templateUrl: './school-field-trips.component.html',
  styleUrl: './school-field-trips.component.scss'
})
export class SchoolFieldTripsComponent {

  #seoService = inject(SeoService);

  constructor() {
    this.#seoService.setUpSEOTags(SEO_PAGES_CONFIG[Pages.schoolFieldTrips]);
  }

  trips = signal<AboutUsProducts[]>([
    {
      title: 'Spring',
      description: `
        <p>
          We'd love for you to join us at Carlton Farms for a fun and educational farm adventure! We have the perfect field trip package for schools, packed with exciting activities that kids will absolutely love.
        </p>
        <p>
          The students will have a wonderful time discovering the history of our farm! They'll get to experience the exciting milking process of a cow. Plus, they'll learn all about how we harvest and pack eggs. And, of course, they'll love visiting the adorable baby animal petting barn with baby cows, pigs, goats, lambs & chicks!
        </p>
        <p>
          We are open for educational field trips from late March through early May each year. (By appointment only)
        </p>
        <p>
          An educational fun-filled day on the farm is <strong>$9 per student or parent/chaperone</strong>. Teachers and bus drivers are welcome at no charge.
        </p>
      `
    },
    {
      title: 'Fall',
      description: `
        <p>
          Come join us at Carlton Farms for a farm experience that is both fun and educational. We offer the perfect field trip package for schools, with many activities for children to enjoy while at the farm. Among the activities provided is a narrated hayride tour of the farm, where you’ll learn the history of our farm and go into the pasture with our friendly milk cows. You’ll be able to feed the cows from the hayride. You’ll also enjoy a trip to our baby animal petting barn, an excellent learning experience for students. Students get the opportunity to learn about our baby animals, as well as pet the baby calves, goats, sheep, miniature donkeys, and pigs. Last – but certainly not least! – you will have a chance to get lost in our corn maze. Students are welcome to bring a lunch to enjoy in our picnic area here on the farm before heading back to school.
        </p>
        <p>
          We are open for educational school field trips from late September through early November each year. (By appointment only)
        </p>
        <p>
          An educational fun-filled day on the farm is $9 per student or parent/chaperone. Teachers and bus drivers are welcome at no charge.
        </p>
      `,
    },
    {
      title: 'Homeschool Groups',
      description: `
        <p>
          We’re excited to let you know that although we’re not hosting a dedicated homeschool day, we’d love to welcome homeschool groups on days when we have smaller school groups visiting! The cost for these days is just <strong>$9 per person</strong>, and we’re happy to say that kids ages 2 and under can join us for free. We can’t wait to see you!
        </p>
      `
    }
  ]);
}
